module.exports = __webpack_public_path__ + "static/media/otros.82bd632f.svg";